import { Component, TemplateRef } from '@angular/core';
import { ToastItem, ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],
  host: {'[class.ngb-toasts]': 'true'}
})
export class ToastComponent{

  constructor(public toastService: ToastService) { }

  isTemplate(toast: ToastItem): boolean { return toast.textOrTpl instanceof TemplateRef; }

}
